import { Text, TextProps, Tooltip, TooltipProps } from "@chakra-ui/react";
import useTextHover from "hooks/useTextHover";
import { memo } from "react";

interface Props {
  tooltipProps?: Omit<TooltipProps, "children">;
  textProps?: TextProps;
  text: string | undefined;
}

const TextWithToolTip = (props: Props) => {
  const { tooltipProps, textProps, text } = props;
  const { hoverStatus, textElementRef } = useTextHover();

  return (
    <Tooltip isDisabled={!hoverStatus} label={text} {...tooltipProps}>
      <Text ref={textElementRef} {...textProps}>
        {text}
      </Text>
    </Tooltip>
  );
};

export default memo(TextWithToolTip);
